const $window = $(window);

$(document).on('click', '.js-toggle-btn', function(e) {
  e.preventDefault();
  const $this = $(this);
  const href = $this.attr('href');
  const btnClass = $this.data('class');
  const btnId = $this.data('id');
  let has_slides = false;

  if (btnClass == 'toggle') {
    $(btnId).toggleClass('expanded');
  }
});
